import React from "react";

type PlayPauseButtonProps = {
  ariaLabel?: string;
  onClick: () => void;
  showPauseIcon: boolean;
};

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  ariaLabel = "Toggle play/pause",
  onClick,
  showPauseIcon,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      onClick={onClick}
      style={{
        position: "absolute",
        left: "50%",
        top: "35%",
        transform: "translate(-50%, -50%)",
        background: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        width: 300,
        height: 300,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 5,
        borderRadius: 9999,
      }}
    >
      {showPauseIcon ? (
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 9999,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 22,
            userSelect: "none",
          }}
        >
          {"❚❚"}
        </div>
      ) : null}
    </button>
  );
};

export default PlayPauseButton;